// extracted by mini-css-extract-plugin
module.exports = {"spining":"spinner_spining__1pNxj"};